import { useEffect, useRef } from 'react';

const DiagonalScroll = ({ services }) => {
  // Triple the services for seamless infinite loop
  const tripleServices = [...services, ...services, ...services];

  return (
    <div className="relative py-12 overflow-hidden" data-testid="diagonal-scroll">
      {/* Background with diagonal gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 via-stone-50 to-teal-50/30"></div>
      
      {/* Content wrapper with diagonal tilt */}
      <div className="relative z-10 py-6 -rotate-2 scale-105">
        {/* First row - scrolling left */}
        <div className="marquee-wrapper mb-8">
          <div className="marquee-content animate-marquee-left">
            {tripleServices.map((service, index) => (
              <ServiceCard key={`row1-${service.id}-${index}`} service={service} />
            ))}
          </div>
        </div>

        {/* Second row - scrolling right */}
        <div className="marquee-wrapper">
          <div className="marquee-content animate-marquee-right">
            {[...tripleServices].reverse().map((service, index) => (
              <ServiceCard key={`row2-${service.id}-${index}`} service={service} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const ServiceCard = ({ service }) => (
  <div className="flex-shrink-0 w-72 md:w-80 mx-3 group cursor-pointer">
    <div className="card-service overflow-hidden hover-lift rotate-2">
      <div className="relative h-44 overflow-hidden">
        <img
          src={service.image_url}
          alt={service.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="font-heading font-semibold text-white text-lg drop-shadow-lg">
            {service.title}
          </h3>
        </div>
      </div>
      <div className="p-4 bg-white">
        <p className="text-stone-600 text-sm line-clamp-2">
          {service.description}
        </p>
      </div>
    </div>
  </div>
);

export default DiagonalScroll;
